import React, { useEffect, useState } from 'react'
import styles from '../../../styles/modules/ChildProfile.module.css'
import { FaUserEdit } from "react-icons/fa";
import { EventAPI } from '../../../api/EventAPI';
import Loader from '../../../component/Loader.jsx'
import { useNavigate } from 'react-router';
import { getLogoByPaymentMethodName } from '../../../util/PaymentUtil.js';
import QRNotFoundImage from '../../../assets/images/qr_not_found.png'

const PlayerInfo = ({ eventId, playerId, isPlayer, qrImg }) => {
    const [playerInfo, setPlayerInfo] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const findPlayerRegistrationInfo = async () => {
        try {
            setIsLoading(true);
            const response = await EventAPI.getEventPlayerFullInfo(eventId, playerId);
           // console.log(response.Data);

            setPlayerInfo(response.Data);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        findPlayerRegistrationInfo();
    }, []);

    const getStepName = (index) => {
        switch (index) {
            case 0:
                return "Player Information";
            case 1:
                return "Participant Fee";
            case 2:
                return "Waiver Details";
            case 3:
                return "Payment Method";
            default:
                return ""
        }

    };

    function formatFieldName(input) {
        if (!input || typeof input !== "string") return input;

        return input
            .split("_")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" ");
    }
    const gotoEditPage = () => {
        navigate(`/edit-player-info/${eventId}`,
            {
                state: {
                    playerFullInfo: playerInfo,
                    isPlayer: isPlayer,
                    playerId: playerId
                }
            }
        );
    };

    if (isLoading) {
        return <Loader />
    }
    async function downloadQRCodeImage() {
        const url = `${import.meta.env.VITE_APP_BASE_URL}/event/player/qr-code-img/${qrImg}`;
        const response = await fetch(url);
        const blob = await response.blob();

        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.href = blobUrl;
        link.download = qrImg;
        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(blobUrl);
        document.body.removeChild(link);
    }
    return (
        <div className={styles['player_info_outer_container']}>
            {qrImg &&
                <>
                    <h2>Check In Details</h2>
                    <hr />
                    <div className={styles['player_info_qr_container']}>
                        <img src={qrImg ? `${import.meta.env.VITE_APP_BASE_URL}/event/player/qr-code-img/${qrImg}` : QRNotFoundImage} alt="qr_code" />
                        <button onClick={downloadQRCodeImage}>Download QR</button>
                    </div>
                </>
            }
            {playerInfo?.map((pi, idx) =>
                <div key={idx} className='player_info_container'>
                    <div className={styles['player_info_heading']}>
                        <h2>{getStepName(idx)}</h2>
                        {idx === 0 && <FaUserEdit className={styles['player_info_edit_icon']} onClick={gotoEditPage} />}
                    </div>
                    <hr />
                    {idx === 0 && Object.entries(pi).map(([key, val]) =>
                        <div className={styles['player_info_sub_heading_con']}>
                            <h3 className={styles['player_info_sub_heading']}>{key?.split('&&&&')[1]}</h3>
                            <div className={styles['player_info_fields_con']}>
                                {Object.entries(val).map(([fieldName, fieldValue]) =>
                                    <div className={styles['player_info_field_info']}>
                                        <h4>{formatFieldName(fieldName)}</h4>
                                        <p>{fieldValue}</p>
                                    </div>)}
                            </div>
                        </div>)}
                    <ul className={styles['player_info_participant_fee']}>
                        {idx === 1 && pi.map((pf) =>
                            <li key={pf?.id}>
                                <div className={styles['player_info_participant_fee_info']}>
                                    <p>{pf?.criteria}</p>
                                    <p>${pf?.feeAmount}</p>
                                </div>
                            </li>
                        )}
                    </ul>
                    <ul className={styles['player_info_participant_fee']}>
                        {idx === 2 && pi.map((w) =>
                            <li key={w?.id}>
                                <div className={styles['player_info_waiver_info']}>
                                    <h4>{w?.name}</h4>
                                    <p>{w?.desc}</p>
                                </div>
                                <br />
                            </li>
                        )}
                    </ul>
                    {idx === 3 &&
                        <div className={styles['player_info_payment_method_con']}>
                            <h4>{pi.type?.replaceAll('_', ' ')}({pi?.name})</h4>
                            <img src={getLogoByPaymentMethodName(pi?.name?.toLowerCase())} alt="" />
                        </div>}
                </div>
            )}
        </div>
    )
}

export default PlayerInfo